export class Beneficiary{
     beneficiaryType : any;
     beneficiaryId : number;
     name : string;
     factsetId : string;
     assignToId : number;
     assignToName : string;
     country: string; //used only on View History option
     investorHasHistory: boolean;
}